import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  height: 6.2rem;
  margin: 2rem 0 0 0.6rem;
  padding: 0.8rem;
  flex-direction: column;
  .tagText {
    margin-left: 1rem;
    cursor: pointer;
    position: relative;
    > span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.6rem;
      height: 2rem;
      background-color: #eef4fd;
      font-size: ${(p) => (p.theme ? p.theme.font.fontSizes.font12 : "1.2rem")};
      color: ${(p) => (p.theme ? p.theme.colors.goBrand.blue : "#2276e3")};
    }
  }
`;

export const ReasonTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  .title {
    color:#141823;
  }
`;

export const ReasonTitle = styled.p(
  (props) => `
  padding-left: 0.4rem;  
  margin: 0 1.45rem 0.6rem 0;
  font-family: ${props.theme.font.fontFamily};
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #2bac36;
`
);

export const ReasonGradient = styled.div`
  margin: 0 0 0 0.5rem;
  border-radius: 0.2rem;
  background-image: linear-gradient(81deg, #00c57e, #18a160);
  height: 2.4rem;
`;

export const ReasonGradientText = styled.p`
  margin: 0 0 0 0.5rem;
  font-family: 'Rubik';
  padding: 0.4rem 0.9rem;
  font-size: 1rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #ffffff;
`;

export const EcoFriendlyImg = styled.img.attrs((props) => ({
  src: props.src || ""
}))`
  width: 20px;
  height: 16px;
`;
